<template>
	<OrganismFormLead
		:webhook="LeadFormWebhooksEnum.SgtTrial"
		:conversion-value="ConversionValuesEnum.SGT"
		:product-name="LeadFormProductsEnum.SgtTrial"
		form-name="sgt-trial"
		submit-button-text="Meedoen aan een proefles!"
		submit-button-icon="fa-bolt"
	/>
</template>

<script lang="ts" setup>
import { LeadFormWebhooksEnum } from '#fit/core/enums/LeadFormWebhooksEnum';
import { ConversionValuesEnum } from '#fit/core/enums/ConversionValuesEnum';
import { LeadFormProductsEnum } from '#fit/core/enums/LeadFormProductsEnum';
</script>
